module.exports = "https://static.cdns.space/tarot-temp/img/blog2-2.a4bdd046.png";